// extracted by mini-css-extract-plugin
export default {"timerWrapper":"Widgets_timerWrapper__VMSNN","buyZenfBtn":"Widgets_buyZenfBtn__pF+wH","message":"Widgets_message__zggM7"};